<template>
  <component
    :is="tagName"
    class="baseAvatar"
    :class="[]" 
  >
  <div class="avatar-image">
    <BaseImage :properties="properties.image" />
  </div>
  <div class="avatar-text" v-if="properties.text">
    <span class="text">
      <BaseText
        class="text"
        :prop="[prop, 'text'].filter((e) => e).join('.')"
        :content="properties.text"
        :options="{
          singleLine: true,
          link: false,
        }"
      />
    </span>
    <span v-if="properties.subtext" class="subtext">
      <BaseText
        :prop="[prop, 'subtext'].filter((e) => e).join('.')"
        :content="properties.subtext"
        :options="{
          singleLine: true,
          link: false,
        }"
      />
    </span>
   </div>
  </component>
</template>

<script>

export const createSelectors = ({name, label, selector}) => [
  {
    name: name,
    label: label,
    selector: `${selector}`,
  },
  {
    name: `${name} Image`,
    label: `${label} Image`,
    selector: `${selector} img`,
  },
  {
    name: `${name} Text`,
    label: `${label} Text`,
    selector: `${selector} .text`,
  },
  {
    name: `${name} Subtext`,
    label: `${label} Subtext`,
    selector: `${selector} .subtext`,
  },
];

export default {
  props: {
    prop: String,
    properties: Object,
    tagName: {
      default: 'div',
    },
    textProps: Object,
  },
};
</script>

<style lang="scss">
.baseAvatar {
  display: flex;
  align-items: center;

  .avatar-image img {
    border-radius: 100%;
    width: 50px;
    height: 50px;
    object-fit: cover;
  }

  .avatar-text {
    margin-left: 10px;
  }
}
</style>
